if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoRotateInterval = null;
      this.autoRotateDelay = 5000; // 5 seconds default
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
          this.resetAutoRotate(); // Reset timer when manually navigating
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
          this.resetAutoRotate(); // Reset timer when manually navigating
        });
      }
      
      // Start auto-rotation if there are multiple slides
      if ( this.length > 1 ) {
        this.startAutoRotate();
        
        // Pause auto-rotation on hover
        this.addEventListener('mouseenter', () => {
          this.pauseAutoRotate();
        });
        
        // Resume auto-rotation when mouse leaves
        this.addEventListener('mouseleave', () => {
          this.startAutoRotate();
        });
      }
      
    }

    changeSlide(direction, allowLoop = false) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
        // Loop back to beginning if at the end (only for auto-rotation)
        if ( this.index >= this.length ) {
          this.index = allowLoop ? 0 : this.length - 1;
        }
      } else if ( direction == 'prev' ) {
        this.index--;
        // Loop to end if at the beginning (only for auto-rotation)
        if ( this.index < 0 ) {
          this.index = allowLoop ? this.length - 1 : 0;
        }
      }

      // Update button states
      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else {
        this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      }
      
      if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      } else {
        this.prevButton.classList.remove('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }
    
    startAutoRotate() {
      // Clear any existing interval
      this.pauseAutoRotate();
      
      // Start new interval with looping enabled
      this.autoRotateInterval = setInterval(() => {
        this.changeSlide('next', true); // Allow looping for auto-rotation
      }, this.autoRotateDelay);
    }
    
    pauseAutoRotate() {
      if ( this.autoRotateInterval ) {
        clearInterval(this.autoRotateInterval);
        this.autoRotateInterval = null;
      }
    }
    
    resetAutoRotate() {
      // Reset the auto-rotate timer
      this.startAutoRotate();
    }
    
    disconnectedCallback() {
      // Clean up interval when component is removed
      this.pauseAutoRotate();
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}